import "../css/header.scss";
import React from "react";
import { Link } from "react-router-dom";
import { FiShoppingBag } from "react-icons/fi";

function Header() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <header className="site-header">
      {/* Top Banner */}
      <div className="top-banner">
        <div className="banner-center">
          <span>FREE RETURNS WITHIN 30 DAYS</span>
        </div>
        <div className="banner-right"></div>
      </div>

      {/* Main Navigation */}
      <div className="main-nav">
        <div className="nav-left">
          <Link to="/" onClick={toTop} className="logo">
            <img src="/head/ovahorizon-wordmark.svg" alt="Ovahorizon" />
          </Link>
        </div>

        <nav className="nav-center">
          <Link to="/shop" onClick={toTop}>
            NEW ARRIVALS
          </Link>
          <Link to="/about" onClick={toTop}>
            OUR BRAND
          </Link>
          <Link to="/contact" onClick={toTop}>
            CONTACT
          </Link>
          <details className="more-menu">
            <summary>MORE</summary>
            <div className="more-links">
              <Link to="/faqs" onClick={toTop}>FAQS</Link>
              <Link to="/shipping" onClick={toTop}>DELIVERY</Link>
              <Link to="/returns" onClick={toTop}>RETURNS</Link>
              <Link to="/privacy" onClick={toTop}>PRIVACY POLICY</Link>
              <Link to="/cookies" onClick={toTop}>COOKIE POLICY</Link>
              <Link to="/terms" onClick={toTop}>TERMS &amp; CONDITIONS</Link>
            </div>
          </details>
        </nav>

        <div className="nav-right">
          <details className="more-menu mobile-more-menu">
            <summary>MORE</summary>
            <div className="more-links">
              <Link to="/faqs" onClick={toTop}>FAQS</Link>
              <Link to="/shipping" onClick={toTop}>DELIVERY</Link>
              <Link to="/returns" onClick={toTop}>RETURNS</Link>
              <Link to="/privacy" onClick={toTop}>PRIVACY POLICY</Link>
              <Link to="/cookies" onClick={toTop}>COOKIE POLICY</Link>
              <Link to="/terms" onClick={toTop}>TERMS &amp; CONDITIONS</Link>
            </div>
          </details>
          <Link
            to="/cartpage"
            onClick={toTop}
            className="icon-btn cart-btn"
            aria-label="Shopping bag"
          >
            <FiShoppingBag size={20} />
          </Link>
        </div>
      </div>
    </header>
  );
}

export default Header;
